/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { IconsInterface } from "components/icons";

const CameraIcon = ({ variant = 'light' }: IconsInterface) => {
  let fill;
  let bg;
  if (variant === "light") {
    fill = "#fff";
    bg = "#565656";
  } else {
    fill = "#000";
    bg = "#fff";
  }
  return (
    <div className="p-2 rounded-full w-fit" style={{ backgroundColor: bg }} test-id="xOwYnfO-">
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg" test-id="RJ__62av">

        <path
          d="M7.46304 0L5.51199 2.1323H2.1323C0.959534 2.1323 0 3.09183 0 4.2646V17.0584C0 18.2311 0.959534 19.1907 2.1323 19.1907H19.1907C20.3634 19.1907 21.323 18.2311 21.323 17.0584V4.2646C21.323 3.09183 20.3634 2.1323 19.1907 2.1323H15.811L13.8599 0H7.46304ZM10.6615 15.9922C7.71892 15.9922 5.33075 13.6041 5.33075 10.6615C5.33075 7.71892 7.71892 5.33075 10.6615 5.33075C13.6041 5.33075 15.9922 7.71892 15.9922 10.6615C15.9922 13.6041 13.6041 15.9922 10.6615 15.9922Z"
          fill={fill} test-id="0Cm4YKvy" />

        <path
          d="M10.6611 14.9264L11.9938 11.9945L14.9257 10.6618L11.9938 9.32913L10.6611 6.39722L9.32839 9.32913L6.39648 10.6618L9.32839 11.9945L10.6611 14.9264Z"
          fill={fill} test-id="WDfAIpkk" />

      </svg>
    </div>);

};

export default CameraIcon;